import { NSABoxSecret, NSARouterMakerResult } from 'namirasoft-account-react';
import { AWSRow, BasicAuthRow, TokenAuthRow } from "namirasoft-credential";
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxInteger, NSBoxString, NSBoxTextArea, NSBoxURL, NSColumn, NSRow } from 'namirasoft-site-react';
import { StorageType } from 'namirasoft-storage';
import { Component, createRef } from 'react';
import { StorageRouterProps } from '../StorageRouterProps';

export interface StorageConnectionEditorProps extends NSARouterMakerResult, StorageRouterProps
{
    type: StorageType | null;
}

export default class StorageConnectionEditor extends Component<StorageConnectionEditorProps>
{
    // 1Fichier
    private NSABoxSecret_1Fichier_APIKey = createRef<NSABoxSecret>();

    // Akamai Net Storage
    private NSBoxString_AkamaiNetStorage_Host = createRef<NSBoxString>();
    private NSBoxString_AkamaiNetStorage_Account = createRef<NSBoxString>();
    private NSABoxSecret_AkamaiNetStorage_Secret = createRef<NSABoxSecret>();

    // AWSS3
    private NSBoxEntity_AWSS3_AWSCredentialID = createRef<NSBoxEntity<AWSRow>>();
    private NSBoxString_AWSS3_Provider = createRef<NSBoxString>();
    private NSBoxString_AWSS3_Region = createRef<NSBoxString>();

    // Azure Blob Storage
    // (1.Certificate)
    // private NSABoxSecret_AzureBlobStorageCertificate_ClientCertificatePassword = createRef<NSABoxSecret>();
    // private NSBoxString_AzureBlobStorageCertificate_ClientCertificatePath = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageCertificate_ClientID = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageCertificate_ClientSendCertificateChain = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageCertificate_Tenant = createRef<NSBoxString>();
    // (2.Key)
    private NSBoxString_AzureBlobStorageKey_Account = createRef<NSBoxString>();
    private NSABoxSecret_AzureBlobStorageKey_Key = createRef<NSABoxSecret>();
    // (3.User Pass)
    // private NSBoxString_AzureBlobStorageUserPass_Tenant = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageUserPass_ClientID = createRef<NSBoxString>();
    // private NSBoxString_AzureBlobStorageUserPass_BasicAuthCredentialID = createRef<NSBoxString>();

    // Azure Files 
    // (1.Certificate)
    // private NSABoxSecret_AzureFilesCertificate_ClientCertificatePassword = createRef<NSABoxSecret>();
    // private NSBoxString_AzureFilesCertificate_ClientCertificatePath = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_ClientID = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_ClientSendCertificateChain = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_Tenant = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesCertificate_ShareName = createRef<NSBoxString>();
    // (2.Connection String)
    // private NSBoxString_AzureFilesConnectionString_ConnectionString = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesConnectionString_ShareName = createRef<NSBoxString>();
    // (3.Key)
    private NSBoxString_AzureFilesKey_Account = createRef<NSBoxString>();
    private NSABoxSecret_AzureFilesKey_Key = createRef<NSABoxSecret>();
    private NSBoxString_AzureFilesKey_ShareName = createRef<NSBoxString>();
    // (4.SAS)
    // private NSBoxURL_AzureFilesSAS_SASURL = createRef<NSBoxURL>();
    // private NSBoxString_AzureFilesSAS_ShareName = createRef<NSBoxString>();
    // (5.User Pass)
    // private NSBoxString_AzureFilesUserPass_Tenant = createRef<NSBoxString>();
    // private NSBoxString_AzureFilesUserPass_ClientID = createRef<NSBoxString>();
    // private NSBoxEntity_AzureFilesUserPass_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    // private NSBoxString_AzureFilesUserPass_ShareName = createRef<NSBoxString>();

    // ‌Back Blaze B2
    private NSBoxString_BackBlazeB2_Account = createRef<NSBoxString>();
    private NSABoxSecret_BackBlazeB2_Key = createRef<NSABoxSecret>();
    private NSBoxString_BackBlazeB2_HardDelete = createRef<NSBoxString>();

    // Box
    private NSBoxEntity_Box_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Citrixe Share File
    private NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Cloudinary
    private NSBoxString_Cloudinary_CloudName = createRef<NSBoxString>();
    private NSABoxSecret_Cloudinary_ApiKey = createRef<NSABoxSecret>();
    private NSABoxSecret_Cloudinary_ApiSecret = createRef<NSABoxSecret>();

    // Dropbox
    private NSBoxEntity_Dropbox_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // File Fabric
    private NSBoxURL_FileFabric_Url = createRef<NSBoxURL>();
    private NSBoxString_FileFabric_RootFolderId = createRef<NSBoxString>();
    private NSBoxEntity_FileFabric_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // File LU
    private NSABoxSecret_FileLU_Key = createRef<NSABoxSecret>();

    // FTP
    private NSBoxString_FTP_Host = createRef<NSBoxString>();
    private NSBoxInteger_FTP_Port = createRef<NSBoxInteger>();
    private NSBoxEntity_FTP_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    private NSBoxString_FTP_TLS = createRef<NSBoxString>();
    private NSBoxString_FTP_ExplicitTLS = createRef<NSBoxString>();

    // GCP Cloud Storage 
    // (1.OAuth2)
    private NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber = createRef<NSBoxInteger>();
    private NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    private NSBoxString_GCPLocation = createRef<NSBoxString>();
    // (2.Service Account File)
    // private NSBoxString_GCPCloudStorageServiceAccountFile_ServiceAccountFile = createRef<NSBoxString>();
    // private NSBoxInteger_GCPCloudStorageServiceAccountFile_ProjectNumber = createRef<NSBoxInteger>();
    // private NSBoxString_GCPCloudStorageServiceAccountFile_Location = createRef<NSBoxString>();

    // GoFile
    private NSBoxEntity_GoFile_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Google Drive 
    // (1.OAuth)
    private NSBoxEntity_GoogleDrive_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    // (2.Service Account)
    // private NSBoxString_GoogleDriveServiceAccount_Scope = createRef<NSBoxString>();
    // private NSBoxString_GoogleDriveServiceAccount_ServiceAccountFile = createRef<NSBoxString>();

    // Google Photos
    private NSBoxEntity_GooglePhotos_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    private NSBoxBoolean_GooglePhotos_ReadOnly = createRef<NSBoxBoolean>();

    // HDFS
    private NSBoxString_HDFS_Namenode = createRef<NSBoxString>();
    private NSBoxString_HDFS_Username = createRef<NSBoxString>();

    // HTTP
    private NSBoxURL_HTTP_Url = createRef<NSBoxURL>();

    // HiDrive
    private NSBoxString_HiDrive_ScopeAccess = createRef<NSBoxString>();
    private NSBoxEntity_HiDrive_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // ICloud Drive
    private NSBoxString_ICloudDrive_AppleID = createRef<NSBoxString>();
    private NSABoxSecret_ICloudDrive_Password = createRef<NSABoxSecret>();

    // ImageKit
    private NSBoxURL_ImageKit_Endpoint = createRef<NSBoxURL>();
    private NSBoxString_ImageKit_PublicKey = createRef<NSBoxString>();
    private NSABoxSecret_ImageKit_PrivateKey = createRef<NSABoxSecret>();

    // Internet Archive
    private NSBoxString_InternetArchive_AccessKeyID = createRef<NSBoxString>();
    private NSABoxSecret_InternetArchive_SecretAccessKey = createRef<NSABoxSecret>();
    private NSBoxString_InternetArchive_ItemDerive = createRef<NSBoxString>();

    // Jottacloud
    private NSBoxURL_Jottacloud_TokenURL = createRef<NSBoxURL>();
    private NSBoxEntity_Jottacloud_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Koofr
    private NSBoxString_Koofr_Provider = createRef<NSBoxString>();
    private NSBoxURL_Koofr_Endpoint = createRef<NSBoxURL>();
    private NSBoxEntity_Koofr_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Linkbox
    private NSBoxEntity_Linkbox_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Mailru
    private NSBoxEntity_Mailru_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Mega
    private NSBoxEntity_Mega_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    private NSBoxString_Mega_2FA = createRef<NSBoxString>();

    // One Drive
    private NSBoxEntity_OneDrive_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    private NSBoxString_OneDrive_Tenant = createRef<NSBoxString>();

    // Open Drive
    private NSBoxEntity_OpenDrive_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Oracle Object Storage
    private NSBoxString_OracleObjectStorage_Provider = createRef<NSBoxString>();
    private NSBoxString_OracleObjectStorage_Namespace = createRef<NSBoxString>();
    private NSBoxString_OracleObjectStorage_Compartment = createRef<NSBoxString>();
    private NSBoxString_OracleObjectStorage_Region = createRef<NSBoxString>();

    // PCloud 
    // (1.OAuth)
    private NSBoxEntity_PCloud_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();
    // (2.User Pass)
    // private NSBoxString_PCloudUserPass_Hostname = createRef<NSBoxString>();
    // private NSBoxEntity_PCloudUserPass_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // PikPak
    private NSBoxEntity_PikPak_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Pixeldrain
    private NSABoxSecret_Pixeldrain_ApiKey = createRef<NSABoxSecret>();

    // PremiumizeMe
    private NSABoxSecret_PremiumizeMe_ApiKey = createRef<NSABoxSecret>();

    // ProtonDrive
    private NSBoxString_ProtonDrive_2FA = createRef<NSBoxString>();
    private NSBoxEntity_ProtonDrive_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Putio
    private NSBoxEntity_Putio_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Qingstor
    private NSBoxString_Qingstor_AccessKeyID = createRef<NSBoxString>();
    private NSABoxSecret_Qingstor_SecretAccessKey = createRef<NSABoxSecret>();
    private NSBoxURL_Qingstor_Endpoint = createRef<NSBoxURL>();
    private NSBoxString_Qingstor_Zone = createRef<NSBoxString>();

    // Quatrix
    private NSABoxSecret_Quatrix_ApiKey = createRef<NSABoxSecret>();
    private NSBoxString_Quatrix_Host = createRef<NSBoxString>();

    // S3
    private NSBoxString_S3_Provider = createRef<NSBoxString>();
    private NSBoxString_S3_AccessKeyID = createRef<NSBoxString>();
    private NSABoxSecret_S3_SecretAccessKey = createRef<NSABoxSecret>();
    private NSBoxString_S3_Region = createRef<NSBoxString>();

    // SFTP
    private NSBoxString_SFTP_Host = createRef<NSBoxString>();
    private NSBoxInteger_SFTP_Port = createRef<NSBoxInteger>();
    private NSBoxTextArea_SFTP_KeyPem = createRef<NSBoxTextArea>();
    private NSBoxString_SFTP_KeyFile = createRef<NSBoxString>();
    private NSABoxSecret_SFTP_KeyFilePass = createRef<NSABoxSecret>();
    private NSBoxEntity_SFTP_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Seafile
    private NSBoxURL_Seafile_Url = createRef<NSBoxURL>();
    private NSBoxString_Seafile_2FA = createRef<NSBoxString>();
    private NSBoxEntity_Seafile_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    private NSBoxString_Seafile_Library = createRef<NSBoxString>();
    private NSABoxSecret_Seafile_LibraryKey = createRef<NSABoxSecret>();

    // Sia
    private NSABoxSecret_Sia_ApiPassword = createRef<NSABoxSecret>();
    private NSBoxURL_Sia_ApiUrl = createRef<NSBoxURL>();

    // SMB
    private NSBoxString_SMB_Host = createRef<NSBoxString>();
    private NSBoxString_SMB_Port = createRef<NSBoxString>();
    private NSBoxEntity_SMB_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();

    // Storj
    private NSABoxSecret_Storj_AccessGrant = createRef<NSABoxSecret>();

    // Swift
    private NSBoxURL_Swift_Auth = createRef<NSBoxURL>();
    private NSABoxSecret_Swift_Key = createRef<NSABoxSecret>();
    private NSBoxString_Swift_User = createRef<NSBoxString>();

    // Ulozto
    private NSBoxEntity_Ulozto_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    private NSBoxEntity_Ulozto_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // WebDAV 
    // (1.User Pass)
    private NSBoxURL_WebDAV_Url = createRef<NSBoxURL>();
    private NSBoxString_WebDAV_Vendor = createRef<NSBoxString>();
    private NSBoxEntity_WebDAV_BasicAuthCredentialID = createRef<NSBoxEntity<BasicAuthRow>>();
    // (2.Bearer Token)
    // private NSBoxURL_WebDAVBearerToken_Url = createRef<NSBoxURL>();
    // private NSBoxString_WebDAVBearerToken_Vendor = createRef<NSBoxString>();
    // private NSABoxSecret_WebDAVBearerToken_BearerToken = createRef<NSABoxSecret>();

    // Yandex
    private NSBoxEntity_Yandex_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    // Zoho
    private NSBoxString_Zoho_Region = createRef<NSBoxString>();
    private NSBoxEntity_Zoho_TokenAuthCredentialID = createRef<NSBoxEntity<TokenAuthRow>>();

    getMeta(type: StorageType): any
    {
        let meta: any = {};
        switch (type)
        {
            case StorageType._1Fichier:
                meta.api_key = this.NSABoxSecret_1Fichier_APIKey.current?.getValue() ?? "";
                break;
            case StorageType.AkamaiNetStorage:
                meta.host = this.NSBoxString_AkamaiNetStorage_Host.current?.getValue() ?? "";
                meta.account = this.NSBoxString_AkamaiNetStorage_Account.current?.getValue() ?? "";
                meta.secret = this.NSABoxSecret_AkamaiNetStorage_Secret.current?.getValue() ?? "";
                break;
            case StorageType.AWSS3:
                meta.aws_credential_id = this.NSBoxEntity_AWSS3_AWSCredentialID.current?.getValueOne() ?? "";
                meta.provider = this.NSBoxString_AWSS3_Provider.current?.getValue() ?? "";
                meta.region = this.NSBoxString_AWSS3_Region.current?.getValue() ?? "";
                break;
            case StorageType.AzureBlobStorage:
                meta.account = this.NSBoxString_AzureBlobStorageKey_Account.current?.getValue() ?? "";
                meta.key = this.NSABoxSecret_AzureBlobStorageKey_Key.current?.getValue() ?? "";
                break;
            case StorageType.AzureFiles:
                meta.account = this.NSBoxString_AzureFilesKey_Account.current?.getValue() ?? "";
                meta.key = this.NSABoxSecret_AzureFilesKey_Key.current?.getValue() ?? "";
                meta.share_name = this.NSBoxString_AzureFilesKey_ShareName.current?.getValue() ?? "";
                break;
            case StorageType.BackBlazeB2:
                meta.account = this.NSBoxString_BackBlazeB2_Account.current?.getValue() ?? "";
                meta.key = this.NSABoxSecret_BackBlazeB2_Key.current?.getValue() ?? "";
                meta.hard_delete = this.NSBoxString_BackBlazeB2_HardDelete.current?.getValue() ?? "";
                break;
            case StorageType.Box:
                meta.token_auth_credential_id = this.NSBoxEntity_Box_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.CitrixeShareFile:
                meta.token_auth_credential_id = this.NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Cloudinary:
                meta.cloud_name = this.NSBoxString_Cloudinary_CloudName.current?.getValue() ?? "";
                meta.api_key = this.NSABoxSecret_Cloudinary_ApiKey.current?.getValue() ?? "";
                meta.api_secret = this.NSABoxSecret_Cloudinary_ApiSecret.current?.getValue() ?? "";
                break;
            case StorageType.DropboxOAuth:
                meta.token_auth_credential_id = this.NSBoxEntity_Dropbox_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.FileFabric:
                meta.url = this.NSBoxURL_FileFabric_Url.current?.getValue() ?? "";
                meta.root_folder_id = this.NSBoxString_FileFabric_RootFolderId.current?.getValue() ?? "";
                meta.token_auth_credential_id = this.NSBoxEntity_FileFabric_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.FileLU:
                meta.key = this.NSABoxSecret_FileLU_Key.current?.getValue() ?? "";
                break;
            case StorageType.FTP:
                meta.host = this.NSBoxString_FTP_Host.current?.getValue() ?? "";
                meta.port = this.NSBoxInteger_FTP_Port.current?.getValue() ?? 0;
                meta.basic_auth_credential_id = this.NSBoxEntity_FTP_BasicAuthCredentialID.current?.getValueOne() ?? "";
                meta.tls = this.NSBoxString_FTP_TLS.current?.getValue() ?? "";
                meta.explicit_tls = this.NSBoxString_FTP_ExplicitTLS.current?.getValue() ?? "";
                break;
            case StorageType.GCPCloudStorage:
                meta.project_number = this.NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber.current?.getValue() ?? 0;
                meta.token_auth_credential_id = this.NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID.current?.getValueOne() ?? "";
                meta.location = this.NSBoxString_GCPLocation.current?.getValue() ?? "";
                break;
            case StorageType.GoFile:
                meta.token_auth_credential_id = this.NSBoxEntity_GoFile_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.GoogleDrive:
                meta.token_auth_credential_id = this.NSBoxEntity_GoogleDrive_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.GooglePhotos:
                meta.token_auth_credential_id = this.NSBoxEntity_GooglePhotos_TokenAuthCredentialID.current?.getValueOne() ?? "";
                meta.read_only = this.NSBoxBoolean_GooglePhotos_ReadOnly.current?.getValue() ?? false;
                break;
            case StorageType.HDFS:
                meta.namenode = this.NSBoxString_HDFS_Namenode.current?.getValue() ?? "";
                meta.username = this.NSBoxString_HDFS_Username.current?.getValue() ?? "";
                break;
            case StorageType.HTTP:
                meta.url = this.NSBoxURL_HTTP_Url.current?.getValue() ?? "";
                break;
            case StorageType.HiDrive:
                meta.scope_access = this.NSBoxString_HiDrive_ScopeAccess.current?.getValue() ?? "";
                meta.token_auth_credential_id = this.NSBoxEntity_HiDrive_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.ICloudDrive:
                meta.apple_id = this.NSBoxString_ICloudDrive_AppleID.current?.getValue() ?? "";
                meta.password = this.NSABoxSecret_ICloudDrive_Password.current?.getValue() ?? "";
                break;
            case StorageType.ImageKit:
                meta.endpoint = this.NSBoxURL_ImageKit_Endpoint.current?.getValue() ?? "";
                meta.public_key = this.NSBoxString_ImageKit_PublicKey.current?.getValue() ?? "";
                meta.private_key = this.NSABoxSecret_ImageKit_PrivateKey.current?.getValue() ?? "";
                break;
            case StorageType.InternetArchive:
                meta.access_key_id = this.NSBoxString_InternetArchive_AccessKeyID.current?.getValue() ?? "";
                meta.secret_access_key = this.NSABoxSecret_InternetArchive_SecretAccessKey.current?.getValue() ?? "";
                meta.item_derive = this.NSBoxString_InternetArchive_ItemDerive.current?.getValue() ?? "";
                break;
            case StorageType.Jottacloud:
                meta.tokenURL = this.NSBoxURL_Jottacloud_TokenURL.current?.getValue() ?? "";
                meta.token_auth_credential_id = this.NSBoxEntity_Jottacloud_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Koofr:
                meta.provider = this.NSBoxString_Koofr_Provider.current?.getValue() ?? "";
                meta.endpoint = this.NSBoxURL_Koofr_Endpoint.current?.getValue() ?? "";
                meta.basic_auth_credential_id = this.NSBoxEntity_Koofr_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Linkbox:
                meta.token_auth_credential_id = this.NSBoxEntity_Linkbox_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Mailru:
                meta.basic_auth_credential_id = this.NSBoxEntity_Mailru_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Mega:
                meta.basic_auth_credential_id = this.NSBoxEntity_Mega_BasicAuthCredentialID.current?.getValueOne() ?? "";
                meta._2fa = this.NSBoxString_Mega_2FA.current?.getValue() ?? "";
                break;
            case StorageType.OneDriveOAuth:
                meta.token_auth_credential_id = this.NSBoxEntity_OneDrive_TokenAuthCredentialID.current?.getValueOne() ?? "";
                meta.tenant = this.NSBoxString_OneDrive_Tenant.current?.getValue() ?? "";
                break;
            case StorageType.OpenDrive:
                meta.basic_auth_credential_id = this.NSBoxEntity_OpenDrive_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.OracleObjectStorage:
                meta.provider = this.NSBoxString_OracleObjectStorage_Provider.current?.getValue() ?? "";
                meta.namespace = this.NSBoxString_OracleObjectStorage_Namespace.current?.getValue() ?? "";
                meta.compartment = this.NSBoxString_OracleObjectStorage_Compartment.current?.getValue() ?? "";
                meta.region = this.NSBoxString_OracleObjectStorage_Region.current?.getValue() ?? "";
                break;
            case StorageType.PCloud:
                meta.token_auth_credential_id = this.NSBoxEntity_PCloud_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.PikPak:
                meta.basic_auth_credential_id = this.NSBoxEntity_PikPak_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Pixeldrain:
                meta.api_key = this.NSABoxSecret_Pixeldrain_ApiKey.current?.getValue() ?? "";
                break;
            case StorageType.PremiumizeMe:
                meta.api_key = this.NSABoxSecret_PremiumizeMe_ApiKey.current?.getValue() ?? "";
                break;
            case StorageType.ProtonDrive:
                meta._2fa = this.NSBoxString_ProtonDrive_2FA.current?.getValue() ?? "";
                meta.basic_auth_credential_id = this.NSBoxEntity_ProtonDrive_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Putio:
                meta.token_auth_credential_id = this.NSBoxEntity_Putio_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Qingstor:
                meta.access_key_id = this.NSBoxString_Qingstor_AccessKeyID.current?.getValue() ?? "";
                meta.secret_access_key = this.NSABoxSecret_Qingstor_SecretAccessKey.current?.getValue() ?? "";
                meta.endpoint = this.NSBoxURL_Qingstor_Endpoint.current?.getValue() ?? "";
                meta.zone = this.NSBoxString_Qingstor_Zone.current?.getValue() ?? "";
                break;
            case StorageType.Quatrix:
                meta.api_key = this.NSABoxSecret_Quatrix_ApiKey.current?.getValue() ?? "";
                meta.host = this.NSBoxString_Quatrix_Host.current?.getValue() ?? "";
                break;
            case StorageType.S3:
                meta.provider = this.NSBoxString_S3_Provider.current?.getValue() ?? "";
                meta.access_key_id = this.NSBoxString_S3_AccessKeyID.current?.getValue() ?? "";
                meta.secret_access_key = this.NSABoxSecret_S3_SecretAccessKey.current?.getValue() ?? "";
                meta.region = this.NSBoxString_S3_Region.current?.getValue() ?? "";
                break;
            case StorageType.SFTP:
                meta.host = this.NSBoxString_SFTP_Host.current?.getValue() ?? "";
                meta.port = this.NSBoxInteger_SFTP_Port.current?.getValue() ?? 0;
                meta.key_pem = this.NSBoxTextArea_SFTP_KeyPem.current?.getValue() ?? "";
                meta.key_file = this.NSBoxString_SFTP_KeyFile.current?.getValue() ?? "";
                meta.key_file_pass = this.NSABoxSecret_SFTP_KeyFilePass.current?.getValue() ?? "";
                meta.basic_auth_credential_id = this.NSBoxEntity_SFTP_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Seafile:
                meta.url = this.NSBoxURL_Seafile_Url.current?.getValue() ?? "";
                meta._2fa = this.NSBoxString_Seafile_2FA.current?.getValue() ?? "";
                meta.basic_auth_credential_id = this.NSBoxEntity_Seafile_BasicAuthCredentialID.current?.getValueOne() ?? "";
                meta.library = this.NSBoxString_Seafile_Library.current?.getValue() ?? "";
                meta.library_key = this.NSABoxSecret_Seafile_LibraryKey.current?.getValue() ?? "";
                break;
            case StorageType.Sia:
                meta.api_url = this.NSBoxURL_Sia_ApiUrl.current?.getValue() ?? "";
                meta.api_password = this.NSABoxSecret_Sia_ApiPassword.current?.getValue() ?? "";
                break;
            case StorageType.SMB:
                meta.host = this.NSBoxString_SMB_Host.current?.getValue() ?? "";
                meta.port = this.NSBoxString_SMB_Port.current?.getValue() ?? "";
                meta.basic_auth_credential_id = this.NSBoxEntity_SMB_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Storj:
                meta.access_grant = this.NSABoxSecret_Storj_AccessGrant.current?.getValue() ?? "";
                break;
            case StorageType.Swift:
                meta.auth = this.NSBoxURL_Swift_Auth.current?.getValue() ?? "";
                meta.key = this.NSABoxSecret_Swift_Key.current?.getValue() ?? "";
                meta.user = this.NSBoxString_Swift_User.current?.getValue() ?? "";
                break;
            case StorageType.Ulozto:
                meta.basic_auth_credential_id = this.NSBoxEntity_Ulozto_BasicAuthCredentialID.current?.getValueOne() ?? "";
                meta.token_auth_credential_id = this.NSBoxEntity_Ulozto_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.WebDAV:
                meta.url = this.NSBoxURL_WebDAV_Url.current?.getValue() ?? "";
                meta.vendor = this.NSBoxString_WebDAV_Vendor.current?.getValue() ?? "";
                meta.basic_auth_credential_id = this.NSBoxEntity_WebDAV_BasicAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Yandex:
                meta.token_auth_credential_id = this.NSBoxEntity_Yandex_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
            case StorageType.Zoho:
                meta.region = this.NSBoxString_Zoho_Region.current?.getValue() ?? "";
                meta.token_auth_credential_id = this.NSBoxEntity_Zoho_TokenAuthCredentialID.current?.getValueOne() ?? "";
                break;
        }
        return meta;
    }

    setMeta(type: StorageType, meta: any): void
    {
        // note: `row.meta` was renamed to `meta` for the local variable
        switch (type)
        {
            case StorageType._1Fichier:
                this.NSABoxSecret_1Fichier_APIKey.current?.setValue(meta.api_key);
                break;
            case StorageType.AkamaiNetStorage:
                this.NSBoxString_AkamaiNetStorage_Host.current?.setValue(meta.host);
                this.NSBoxString_AkamaiNetStorage_Account.current?.setValue(meta.account);
                this.NSABoxSecret_AkamaiNetStorage_Secret.current?.setValue(meta.secret);
                break;
            case StorageType.AWSS3:
                this.NSBoxEntity_AWSS3_AWSCredentialID.current?.setValueOne(meta.aws_credential_id);
                this.NSBoxString_AWSS3_Provider.current?.setValue(meta.provider);
                this.NSBoxString_AWSS3_Region.current?.setValue(meta.region);
                break;
            case StorageType.AzureBlobStorage:
                this.NSBoxString_AzureBlobStorageKey_Account.current?.setValue(meta.account);
                this.NSABoxSecret_AzureBlobStorageKey_Key.current?.setValue(meta.key);
                break;
            case StorageType.AzureFiles:
                this.NSBoxString_AzureFilesKey_Account.current?.setValue(meta.account);
                this.NSABoxSecret_AzureFilesKey_Key.current?.setValue(meta.key);
                this.NSBoxString_AzureFilesKey_ShareName.current?.setValue(meta.share_name);
                break;
            case StorageType.BackBlazeB2:
                this.NSBoxString_BackBlazeB2_Account.current?.setValue(meta.account);
                this.NSABoxSecret_BackBlazeB2_Key.current?.setValue(meta.key);
                this.NSBoxString_BackBlazeB2_HardDelete.current?.setValue(meta.hard_delete);
                break;
            case StorageType.Box:
                this.NSBoxEntity_Box_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.CitrixeShareFile:
                this.NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.Cloudinary:
                this.NSBoxString_Cloudinary_CloudName.current?.setValue(meta.cloud_name);
                this.NSABoxSecret_Cloudinary_ApiKey.current?.setValue(meta.api_key);
                this.NSABoxSecret_Cloudinary_ApiSecret.current?.setValue(meta.api_secret);
                break;
            case StorageType.DropboxOAuth:
                this.NSBoxEntity_Dropbox_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.FileFabric:
                this.NSBoxURL_FileFabric_Url.current?.setValue(meta.url);
                this.NSBoxString_FileFabric_RootFolderId.current?.setValue(meta.root_folder_id);
                this.NSBoxEntity_FileFabric_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.FileLU:
                this.NSABoxSecret_FileLU_Key.current?.setValue(meta.key);
                break;
            case StorageType.FTP:
                this.NSBoxString_FTP_Host.current?.setValue(meta.host);
                this.NSBoxInteger_FTP_Port.current?.setValue(meta.port);
                this.NSBoxEntity_FTP_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                this.NSBoxString_FTP_TLS.current?.setValue(meta.tls);
                this.NSBoxString_FTP_ExplicitTLS.current?.setValue(meta.explicit_tls);
                break;
            case StorageType.GCPCloudStorage:
                this.NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber.current?.setValue(meta.project_number);
                this.NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                this.NSBoxString_GCPLocation.current?.setValue(meta.location);
                break;
            case StorageType.GoFile:
                this.NSBoxEntity_GoFile_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.GoogleDrive:
                this.NSBoxEntity_GoogleDrive_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.GooglePhotos:
                this.NSBoxEntity_GooglePhotos_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                this.NSBoxBoolean_GooglePhotos_ReadOnly.current?.setValue(meta.read_only);
                break;
            case StorageType.HDFS:
                this.NSBoxString_HDFS_Namenode.current?.setValue(meta.namenode);
                this.NSBoxString_HDFS_Username.current?.setValue(meta.username);
                break;
            case StorageType.HTTP:
                this.NSBoxURL_HTTP_Url.current?.setValue(meta.url);
                break;
            case StorageType.HiDrive:
                this.NSBoxString_HiDrive_ScopeAccess.current?.setValue(meta.scope_access);
                this.NSBoxEntity_HiDrive_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.ICloudDrive:
                this.NSBoxString_ICloudDrive_AppleID.current?.setValue(meta.apple_id);
                this.NSABoxSecret_ICloudDrive_Password.current?.setValue(meta.password);
                break;
            case StorageType.ImageKit:
                this.NSBoxURL_ImageKit_Endpoint.current?.setValue(meta.endpoint);
                this.NSBoxString_ImageKit_PublicKey.current?.setValue(meta.public_key);
                this.NSABoxSecret_ImageKit_PrivateKey.current?.setValue(meta.private_key);
                break;
            case StorageType.InternetArchive:
                this.NSBoxString_InternetArchive_AccessKeyID.current?.setValue(meta.access_key_id);
                this.NSABoxSecret_InternetArchive_SecretAccessKey.current?.setValue(meta.secret_access_key);
                this.NSBoxString_InternetArchive_ItemDerive.current?.setValue(meta.item_derive);
                break;
            case StorageType.Jottacloud:
                this.NSBoxURL_Jottacloud_TokenURL.current?.setValue(meta.tokenURL);
                this.NSBoxEntity_Jottacloud_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.Koofr:
                this.NSBoxString_Koofr_Provider.current?.setValue(meta.provider);
                this.NSBoxURL_Koofr_Endpoint.current?.setValue(meta.endpoint);
                this.NSBoxEntity_Koofr_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.Linkbox:
                this.NSBoxEntity_Linkbox_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.Mailru:
                this.NSBoxEntity_Mailru_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.Mega:
                this.NSBoxEntity_Mega_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                this.NSBoxString_Mega_2FA.current?.setValue(meta._2fa);
                break;
            case StorageType.OneDriveOAuth:
                this.NSBoxEntity_OneDrive_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                this.NSBoxString_OneDrive_Tenant.current?.setValue(meta.tenant);
                break;
            case StorageType.OpenDrive:
                this.NSBoxEntity_OpenDrive_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.OracleObjectStorage:
                this.NSBoxString_OracleObjectStorage_Provider.current?.setValue(meta.provider);
                this.NSBoxString_OracleObjectStorage_Namespace.current?.setValue(meta.namespace);
                this.NSBoxString_OracleObjectStorage_Compartment.current?.setValue(meta.compartment);
                this.NSBoxString_OracleObjectStorage_Region.current?.setValue(meta.region);
                break;
            case StorageType.PCloud:
                this.NSBoxEntity_PCloud_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.PikPak:
                this.NSBoxEntity_PikPak_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.Pixeldrain:
                this.NSABoxSecret_Pixeldrain_ApiKey.current?.setValue(meta.api_key);
                break;
            case StorageType.PremiumizeMe:
                this.NSABoxSecret_PremiumizeMe_ApiKey.current?.setValue(meta.api_key);
                break;
            case StorageType.ProtonDrive:
                this.NSBoxString_ProtonDrive_2FA.current?.setValue(meta._2fa);
                this.NSBoxEntity_ProtonDrive_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.Putio:
                this.NSBoxEntity_Putio_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.Qingstor:
                this.NSBoxString_Qingstor_AccessKeyID.current?.setValue(meta.access_key_id);
                this.NSABoxSecret_Qingstor_SecretAccessKey.current?.setValue(meta.secret_access_key);
                this.NSBoxURL_Qingstor_Endpoint.current?.setValue(meta.endpoint);
                this.NSBoxString_Qingstor_Zone.current?.setValue(meta.zone);
                break;
            case StorageType.Quatrix:
                this.NSABoxSecret_Quatrix_ApiKey.current?.setValue(meta.api_key);
                this.NSBoxString_Quatrix_Host.current?.setValue(meta.host);
                break;
            case StorageType.S3:
                this.NSBoxString_S3_Provider.current?.setValue(meta.provider);
                this.NSBoxString_S3_AccessKeyID.current?.setValue(meta.access_key_id);
                this.NSABoxSecret_S3_SecretAccessKey.current?.setValue(meta.secret_access_key);
                this.NSBoxString_S3_Region.current?.setValue(meta.region);
                break;
            case StorageType.SFTP:
                this.NSBoxString_SFTP_Host.current?.setValue(meta.host);
                this.NSBoxInteger_SFTP_Port.current?.setValue(meta.port);
                this.NSBoxTextArea_SFTP_KeyPem.current?.setValue(meta.key_pem);
                this.NSBoxString_SFTP_KeyFile.current?.setValue(meta.key_file);
                this.NSABoxSecret_SFTP_KeyFilePass.current?.setValue(meta.key_file_pass);
                this.NSBoxEntity_SFTP_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.Seafile:
                this.NSBoxURL_Seafile_Url.current?.setValue(meta.url);
                this.NSBoxString_Seafile_2FA.current?.setValue(meta._2fa);
                this.NSBoxEntity_Seafile_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                this.NSBoxString_Seafile_Library.current?.setValue(meta.library);
                this.NSABoxSecret_Seafile_LibraryKey.current?.setValue(meta.library_key);
                break;
            case StorageType.Sia:
                this.NSBoxURL_Sia_ApiUrl.current?.setValue(meta.api_url);
                this.NSABoxSecret_Sia_ApiPassword.current?.setValue(meta.api_password);
                break;
            case StorageType.SMB:
                this.NSBoxString_SMB_Host.current?.setValue(meta.host);
                this.NSBoxString_SMB_Port.current?.setValue(meta.port);
                this.NSBoxEntity_SMB_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.Storj:
                this.NSABoxSecret_Storj_AccessGrant.current?.setValue(meta.access_grant);
                break;
            case StorageType.Swift:
                this.NSBoxURL_Swift_Auth.current?.setValue(meta.auth);
                this.NSABoxSecret_Swift_Key.current?.setValue(meta.key);
                this.NSBoxString_Swift_User.current?.setValue(meta.user);
                break;
            case StorageType.Ulozto:
                this.NSBoxEntity_Ulozto_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                this.NSBoxEntity_Ulozto_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.WebDAV:
                this.NSBoxURL_WebDAV_Url.current?.setValue(meta.url);
                this.NSBoxString_WebDAV_Vendor.current?.setValue(meta.vendor);
                this.NSBoxEntity_WebDAV_BasicAuthCredentialID.current?.setValueOne(meta.basic_auth_credential_id);
                break;
            case StorageType.Yandex:
                this.NSBoxEntity_Yandex_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
            case StorageType.Zoho:
                this.NSBoxString_Zoho_Region.current?.setValue(meta.region);
                this.NSBoxEntity_Zoho_TokenAuthCredentialID.current?.setValueOne(meta.token_auth_credential_id);
                break;
        }
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        return (
            <NSColumn style={{ maxWidth: "35rem" }}>
                <NSRow style={{ justifyContent: "flex-start" }}>
                    {
                        this.props.type === StorageType._1Fichier &&
                        <NSABoxSecret
                            {...this.props}
                            ref={this.NSABoxSecret_1Fichier_APIKey}
                            title="API Key"
                            required
                            auto_complete='one-time-code'
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.AkamaiNetStorage &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_AkamaiNetStorage_Account}
                                title="Account"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_AkamaiNetStorage_Host}
                                title="Host"
                                required
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_AkamaiNetStorage_Secret}
                                {...this.props}
                                title="Secret"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.AWSS3 &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_AWSS3_Provider}
                                title="Provider"
                                required
                                auto_complete='one-time-code'
                            />
                            <NSBoxString
                                ref={this.NSBoxString_AWSS3_Region}
                                title="Region"
                                required
                                auto_complete='one-time-code'
                            />
                            <NSBoxEntity<AWSRow>
                                ref={this.NSBoxEntity_AWSS3_AWSCredentialID}
                                title="AWS Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.aws}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.AzureBlobStorage &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_AzureBlobStorageKey_Account}
                                title="Account"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_AzureBlobStorageKey_Key}
                                {...this.props}
                                title="Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.AzureFiles &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_AzureFilesKey_Account}
                                title="Account"
                                required
                                auto_complete='one-time-code'
                            />
                            <NSBoxString
                                ref={this.NSBoxString_AzureFilesKey_ShareName}
                                title="Share Name"
                                required
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_AzureFilesKey_Key}
                                {...this.props}
                                title="Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.BackBlazeB2 &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_BackBlazeB2_Account}
                                title="Account"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_BackBlazeB2_HardDelete}
                                title="Hard Delete"
                                required
                            />
                            <NSABoxSecret
                                {...this.props}
                                ref={this.NSABoxSecret_BackBlazeB2_Key}
                                title="Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Box &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_Box_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.CitrixeShareFile &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_CitrixeShareFile_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.Cloudinary &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_Cloudinary_CloudName}
                                title="Cloud Name"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Cloudinary_ApiKey}
                                {...this.props}
                                title="API Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Cloudinary_ApiSecret}
                                {...this.props}
                                title="API Secret"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.DropboxOAuth &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_Dropbox_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.FileFabric &&
                        <>
                            <NSBoxURL
                                ref={this.NSBoxURL_FileFabric_Url}
                                title="URL"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_FileFabric_RootFolderId}
                                title="Root Folder ID"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_FileFabric_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.FileLU &&
                        <NSABoxSecret
                            ref={this.NSABoxSecret_FileLU_Key}
                            {...this.props}
                            title="Key"
                            required
                            auto_complete='one-time-code'
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.FTP &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_FTP_Host}
                                title="Host"
                                required
                            />
                            <NSBoxInteger
                                ref={this.NSBoxInteger_FTP_Port}
                                title="Port"
                                required
                            />
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_FTP_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_FTP_TLS}
                                title="TLS"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_FTP_ExplicitTLS}
                                title="Explicit TLS"
                                required
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.GCPCloudStorage &&
                        <>
                            <NSBoxInteger
                                ref={this.NSBoxInteger_GCPCloudStorageOAuth2_ProjectNumber}
                                title="Project Number"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_GCPLocation}
                                title="Location"
                                required
                            />
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_GCPCloudStorageOAuth2_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.GoFile &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_GoFile_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.GoogleDrive &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_GoogleDrive_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.GooglePhotos &&
                        <>
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_GooglePhotos_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxBoolean
                                ref={this.NSBoxBoolean_GooglePhotos_ReadOnly}
                                title="Read Only"
                                required
                                hideHeader
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.HDFS &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_HDFS_Namenode}
                                title="Namenode"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_HDFS_Username}
                                title="Username"
                                required
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.HTTP &&
                        <NSBoxURL
                            ref={this.NSBoxURL_HTTP_Url}
                            title="URL"
                            required
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.HiDrive &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_HiDrive_ScopeAccess}
                                title="Scope Access"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_HiDrive_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.ICloudDrive &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_ICloudDrive_AppleID}
                                title="Apple ID"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_ICloudDrive_Password}
                                {...this.props}
                                title="Password"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.ImageKit &&
                        <>
                            <NSBoxURL
                                ref={this.NSBoxURL_ImageKit_Endpoint}
                                title="Endpoint"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_ImageKit_PublicKey}
                                title="Public Key"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_ImageKit_PrivateKey}
                                {...this.props}
                                title="Private Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.InternetArchive &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_InternetArchive_AccessKeyID}
                                title="Access Key ID"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_InternetArchive_ItemDerive}
                                title="Item Derive"
                                required
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_InternetArchive_SecretAccessKey}
                                {...this.props}
                                title="Secret Access Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Jottacloud &&
                        <>
                            <NSBoxURL
                                ref={this.NSBoxURL_Jottacloud_TokenURL}
                                title="Token URL"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Jottacloud_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Koofr &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_Koofr_Provider}
                                title="Provider"
                                required
                            />
                            <NSBoxURL
                                ref={this.NSBoxURL_Koofr_Endpoint}
                                title="Endpoint"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_Koofr_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Linkbox &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_Linkbox_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.Mailru &&
                        <NSBoxEntity<BasicAuthRow>
                            ref={this.NSBoxEntity_Mailru_BasicAuthCredentialID}
                            title="Basic Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.basic_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.Mega &&
                        <>
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_Mega_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_Mega_2FA}
                                title="2FA"
                                required={false}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.OneDriveOAuth &&
                        <>
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_OneDrive_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_OneDrive_Tenant}
                                title="Tenant"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.OpenDrive &&
                        <NSBoxEntity<BasicAuthRow>
                            ref={this.NSBoxEntity_OpenDrive_BasicAuthCredentialID}
                            title="Basic Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.basic_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.OracleObjectStorage &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_OracleObjectStorage_Provider}
                                title="Provider"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_OracleObjectStorage_Namespace}
                                title="Namespace"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_OracleObjectStorage_Compartment}
                                title="Compartment"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_OracleObjectStorage_Region}
                                title="Region"
                                required
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.PCloud &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_PCloud_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.PikPak &&
                        <NSBoxEntity<BasicAuthRow>
                            ref={this.NSBoxEntity_PikPak_BasicAuthCredentialID}
                            title="Basic Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.basic_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.Pixeldrain &&
                        <NSABoxSecret
                            ref={this.NSABoxSecret_Pixeldrain_ApiKey}
                            {...this.props}
                            title="API Key"
                            required
                            auto_complete='one-time-code'
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.PremiumizeMe &&
                        <NSABoxSecret
                            ref={this.NSABoxSecret_PremiumizeMe_ApiKey}
                            {...this.props}
                            title="API Key"
                            required
                            auto_complete='one-time-code'
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.ProtonDrive &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_ProtonDrive_2FA}
                                title="2FA"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_ProtonDrive_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Putio &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_Putio_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.Qingstor &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_Qingstor_AccessKeyID}
                                title="Access Key ID"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Qingstor_SecretAccessKey}
                                {...this.props}
                                title="Secret Access Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxURL
                                ref={this.NSBoxURL_Qingstor_Endpoint}
                                title="Endpoint"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_Qingstor_Zone}
                                title="Zone"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Quatrix &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_Quatrix_Host}
                                title="Host"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Quatrix_ApiKey}
                                {...this.props}
                                title="API Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.S3 &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_S3_Provider}
                                title="Provider"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_S3_Region}
                                title="Region"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_S3_AccessKeyID}
                                title="Access Key ID"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_S3_SecretAccessKey}
                                {...this.props}
                                title="Secret Access Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.SFTP &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_SFTP_Host}
                                title="Host"
                                required
                            />
                            <NSBoxInteger
                                ref={this.NSBoxInteger_SFTP_Port}
                                title="Port"
                                required
                            />
                            <NSBoxTextArea
                                ref={this.NSBoxTextArea_SFTP_KeyPem}
                                title="Key PEM"
                                required={false}
                                style={{ width: "100%" }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_SFTP_KeyFile}
                                title="Key File"
                                required={false}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_SFTP_KeyFilePass}
                                {...this.props}
                                title="Key File Password"
                                required={false}
                                auto_complete='one-time-code'
                            />
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_SFTP_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required={false}
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Seafile &&
                        <>
                            <NSBoxURL
                                ref={this.NSBoxURL_Seafile_Url}
                                title="URL"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_Seafile_2FA}
                                title="2FA"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_Seafile_Library}
                                title="Library"
                                required
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Seafile_LibraryKey}
                                {...this.props}
                                title="Library Key"
                                required
                                auto_complete='one-time-code'
                            />
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_Seafile_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Sia &&
                        <>
                            <NSBoxURL
                                ref={this.NSBoxURL_Sia_ApiUrl}
                                title="API URL"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Sia_ApiPassword}
                                {...this.props}
                                title="API Password"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.SMB &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_SMB_Host}
                                title="Host"
                                required
                            />
                            <NSBoxString
                                ref={this.NSBoxString_SMB_Port}
                                title="Port"
                                required
                            />
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_SMB_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Storj &&
                        <NSABoxSecret
                            ref={this.NSABoxSecret_Storj_AccessGrant}
                            {...this.props}
                            title="Access Grant"
                            required
                            auto_complete='one-time-code'
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.Swift &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_Swift_User}
                                title="User"
                                required
                            />
                            <NSBoxURL
                                ref={this.NSBoxURL_Swift_Auth}
                                title="Auth"
                                required
                            />
                            <NSABoxSecret
                                ref={this.NSABoxSecret_Swift_Key}
                                {...this.props}
                                title="Key"
                                required
                                auto_complete='one-time-code'
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Ulozto &&
                        <>
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_Ulozto_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Ulozto_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.WebDAV &&
                        <>
                            <NSBoxURL
                                ref={this.NSBoxURL_WebDAV_Url}
                                title="URL"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxString
                                ref={this.NSBoxString_WebDAV_Vendor}
                                title="Vendor"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<BasicAuthRow>
                                ref={this.NSBoxEntity_WebDAV_BasicAuthCredentialID}
                                title="Basic Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.basic_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                    {
                        this.props.type === StorageType.Yandex &&
                        <NSBoxEntity<TokenAuthRow>
                            ref={this.NSBoxEntity_Yandex_TokenAuthCredentialID}
                            title="Token Auth Credential"
                            required
                            multiple={false}
                            table={namirasoft.credential.tables.token_auth}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    }
                    {
                        this.props.type === StorageType.Zoho &&
                        <>
                            <NSBoxString
                                ref={this.NSBoxString_Zoho_Region}
                                title="Region"
                                required
                                style={{ width: NSBox.width.double }}
                            />
                            <NSBoxEntity<TokenAuthRow>
                                ref={this.NSBoxEntity_Zoho_TokenAuthCredentialID}
                                title="Token Auth Credential"
                                required
                                multiple={false}
                                table={namirasoft.credential.tables.token_auth}
                                getTitle={(item) => item.name}
                                getValue={(item) => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                            />
                        </>
                    }
                </NSRow>
            </NSColumn>
        );
    }
}